import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api/gameApi'
import {
  getCountScoreSuccess,
  getCountScoreFailed,
  GET_COUNT_SCORE_SNAPSHOT_START,
} from '~/views/app/redux/actions/user'

/**
 * get score snapshot by wallet api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */

const getCountScoreSnapshotApi = (props) => {
  var uri = `/api/game/score-snapshot/count`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */

function* doGetCountScoreSnapshot(action) {
  try {
    const response = yield call(getCountScoreSnapshotApi, action?.payload)
    yield put(getCountScoreSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getCountScoreFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}
/**
 * [Watcher]
 * Watch get score snapshot by wallet
 */
export default function* watchGetCountScoreSnapshot() {
  yield takeLatest(GET_COUNT_SCORE_SNAPSHOT_START, doGetCountScoreSnapshot)
}
